import React from "react";
import { MusicPracticeRoomContactContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { HeaderBackMusicPracticeWidget } from "widgets";
import { Displays, Forms, Headers, Navigations } from "components";

// ขั้นข้อมูลติดต่อของห้องซ้อม (เลือกห้อง -> ข้อมูลติดต่อ -> วัน/เวลา/หมายเหตุ)
// ใช้ฟอร์มเดียวกับ Music Hall: booker_* ส่งต่อทาง url ไปจนถึง step 2 ที่บันทึกร่าง
// อีเมลยืนยัน/แจ้งโอนเงินจะส่งไปที่ booker_email นี้ (ไม่ใช่อีเมลที่ใช้สมัครสมาชิก)
// หน้าตรวจสอบข้อมูล (is_preview=true) ใช้ container นี้แบบ disabled
class MusicPracticeRoomContactContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { router } = this.props;
    this.setState({
      initialValues: {
        ...queryString.parse(router.location.search),
      },
      isLoading: false,
    });
  };

  handleBack = () => {
    const { router } = this.props;
    const { id } = router.params;
    router.navigate(
      `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${id}/booking/1${router.location.search}`,
    );
  };

  handleSubmit = (values) => {
    const { router } = this.props;
    const { id } = router.params;
    const { initialValues } = this.state;
    const query = new URLSearchParams({
      ...initialValues,
      ...values,
    }).toString();
    router.navigate(`${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${id}/booking/2?${query}`);
  };

  render() {
    const { router, t, authenRedux } = this.props;
    const { isLoading, initialValues } = this.state;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Practice Room", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}`,
      },
    ];
    return (
      <MusicPracticeRoomContactContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="music_practice_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"MUSIC PRACTICE ROOM"}
                sub_title={"ห้องซ้อมดนตรี"}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicPracticeWidget
                room_booking_id={
                  queryString.parse(router.location.search)?.room_id
                }
              />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              // ห้องซ้อมใช้ "รายละเอียดผู้เข้าใช้บริการ" (music hall ยังเป็น "ข้อมูลติดต่อ (ผู้จัดงาน/ผู้ประสานงาน)")
              title_reserve={t("Service User Details", { ns: "room" })}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Forms.MusicHallRegisContactInfoForm
              isDisabledForm={isPreview}
              initialValues={initialValues}
              memberInfo={authenRedux}
              onBack={this.handleBack}
              onSubmit={this.handleSubmit}
            />
          )}
        </div>
      </MusicPracticeRoomContactContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withTranslation(["common", "room"])(
    withRouter(MusicPracticeRoomContactContainer),
  ),
);
